import { skipToken, useQuery } from "@tanstack/react-query";
import { affiliateCodeKeys } from "Api/Queries/Affiliate/useAffiliateReferrerQuery";
import { getLeadsAffiliateCodesCode } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import type { AffiliateUserRole } from "Types/types";

/** Checks a typed affiliate code for the role and tells who it belongs to. Idle while code is null. */
export const useVerifyAffiliateCodeQuery = (
  role: AffiliateUserRole,
  code: string | null,
) =>
  useQuery({
    queryKey: affiliateCodeKeys.verification(role, code),
    queryFn: code
      ? processResponseWithApiProblemDetails(() =>
          getLeadsAffiliateCodesCode(code, role),
        )
      : skipToken,
    refetchOnWindowFocus: false,
    // A rejected code is a 4xx answer, not a failure worth retrying.
    retry: false,
  });
